import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenCheck, Gauge, LaptopMinimal, Smartphone, Zap } from 'lucide-react';
const benefits = [{
  icon: Gauge,
  text: 'Aprende a tu ritmo.'
}, {
  icon: Zap,
  text: 'Acceso inmediato.'
}, {
  icon: LaptopMinimal,
  text: 'Compatible con computadora, tablet y celular.'
}, {
  icon: BookOpenCheck,
  text: 'Explicaciones paso a paso.'
}, {
  icon: Smartphone,
  text: 'Material organizado para principiantes.'
}];
export function Benefits() {
  return <section className="bg-brand-beige/65 px-5 py-20 sm:px-6 md:py-28" data-id="element-59" data-mp="3ms578uvvj1st">
      <div className="mx-auto max-w-6xl" data-id="element-60" data-mp="3hrqytbqd1pu9">
        <FadeIn data-id="element-61" data-mp="3crurp3md9iah">
          <div className="mx-auto mb-12 max-w-2xl text-center md:mb-14" data-id="element-62" data-mp="3cse8ui4702ng">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-63" data-mp="3cu7im6a3r2zo">
              Diseñado para avanzar
            </p>
            <h2 className="font-serif text-3xl font-bold tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-64" data-mp="1b1jd1q9zk3gq">
              Una experiencia clara desde el primer día.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5" data-id="element-65" data-mp="6ucnrp2vakz5">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <FadeIn key={benefit.text} delay={0.07 * index} data-id="element-66" data-mp="3tyaeskm3l1nw" data-mpi={index}>
                <article className="h-full rounded-2xl border border-brand-text/8 bg-white p-6 text-center shadow-[0_8px_28px_-18px_rgba(26,26,26,0.18)]" data-id="element-67" data-mp="lh5u44uesgf7">
                  <span className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-green/8" data-id="element-68" data-mp="qfzbw9gqatl6">
                    <Icon className="h-6 w-6 text-brand-green" data-id="element-69" data-mp="gqz90ez3ve1p" />
                  </span>
                  <p className="text-sm font-semibold leading-relaxed text-brand-text/80" data-id="element-70" data-mp="gomfr5nwdh9c">
                    {benefit.text}
                  </p>
                </article>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}